export default "__VITE_ASSET__Cq6dMIH$__"